import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import composes from '../../../../common/utils/composes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import EventActions from '../../actions/events';
import { getEvent } from '../../selectors/events';
import { withLoading } from '../../../../redux-modules/loading-overlay';
import {withCustomerOrg, NotFound, Button} from '../../../../common/components';
import {
  TitleBar,
  ServiceDialog,
  DocTitle
} from '../../../../common/components/Layout/StandardPageTemplate/Context';
import Message from '../../components/Message';
import RegisterView from './RegisterView';
import PaymentView from './Payment';
import ConfirmationView from './Confirmation';
import * as helpers from './data-helpers';

class EventDetail extends React.Component {
  static propTypes = {
    event: PropTypes.shape({
      title: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
    actions: PropTypes.shape({
      events: PropTypes.object,
    }),
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_GET',
        meta: { namespace: 'events' },
      },
    ],
  };
  state = {
    serverError: false,
    isFetching: false,
  };

  componentDidMount() {
    const { actions, match: { params: { eventId } = {} } = {} } = this.props;
    if (eventId) {
      this.setState({ isFetching: true });
      actions.events
        .get(eventId)
        .then(result => {
          this.setState({ isFetching: false });
          this.checkServerError(result);
        })
        .catch(() => this.setState({ isFetching: false }));
    }
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  // TODO: can we centralize this somehow?
  checkServerError = ({ payload: { resp: { status = 0 } = {} } = {} }) => {
    if (status >= 500 && status < 600) {
      this.setState({ serverError: true });
    }
  };

  render() {
    const {event, match: {path}, isLoading, ...restProps} = this.props; //eslint-disable-line no-unused-vars
    const {serverError, isFetching} = this.state;
    const forwardProps = {event, ...restProps};

    return (
      <div>
        {serverError ? <ServiceDialog /> : null}
        <DocTitle title="Detail | Events | NFIB" />
        <TitleBar title="">
          <Button
            type="text"
            label="Go to Events"
            to="/events"
            onClick={() => window.scrollTo(0, 0)}
          />
        </TitleBar>
        {isFetching ? (
          <Message>Loading</Message>
        ) : event ? (
          <Switch>
            <Route
              path={`${path}/register`}
              render={props => <RegisterView {...props} {...forwardProps} />}
            />
            <Route
              path={`${path}/payment`}
              render={props => <PaymentView {...forwardProps} {...props} />}
            />
            <Route
              path={`${path}/confirmation`}
              render={props => (
                <ConfirmationView {...forwardProps} {...props} />
              )}
            />
            <Route
              render={props => <RegisterView {...props} {...forwardProps} />}
            />
          </Switch>
        ) : (
          <NotFound
            title="Sorry"
            subtitle="We couldn't find the event you're looking for."
            redirectMessage="Go to Event Catalog"
            reactRouterLocation="/events"
          />
        )}
        <br />
        <Button
          type="text"
          label="Go to Events"
          to="/events"
          onClick={() => window.scrollTo(0, 0)}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      events: bindActionCreators(EventActions, dispatch),
    },
  };
};

const mapStateToProps = (state, ownProps) => {
  const {
    match: { params: { eventId: id = '' } = {} } = {},
    currentCustomer,
  } = ownProps;
  const event = getEvent(state, { id });
  const isUserMember = helpers.isMember(currentCustomer);
  const userPrices =
    event && event.pricing
      ? event.pricing.filter(
          price =>
            price.isCurrentlyAvailable &&
            helpers.isValidPrice(event, isUserMember)(price)
        )
      : [];
  return {
    event,
    isUserMember,
    userPrices,
  };
};

export default composes(
  EventDetail,
  withLoading,
  connect(mapStateToProps, mapDispatchToProps),
  withCustomerOrg
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/index.js